import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { clsx } from 'clsx';
import { Tooltip } from '@mui/material';
import {
  faClose,
  faSquareArrowDownRight,
} from '@fortawesome/pro-solid-svg-icons';
import { createPortal } from 'react-dom';
import { useWorkoutClipboardStore } from '../../../../stores/workoutClipboard.store';
import _ from 'lodash';
import { sprinkles } from '@design-system/sprinkles.css';
import { ClipboardPanel } from './ClipboardPanel';
import auth from '@client/components/auth';
import { WorkoutItem } from '../../models/workout.domain';

export const WorkoutClipboard = ({
  paste,
  disabledPaste,
  onOpen,
}: {
  paste: (values: WorkoutItem[]) => void;
  disabledPaste?: boolean;
  onOpen: () => void;
}) => {
  const { data, deleteItem, clearAll } = useWorkoutClipboardStore();
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    const afterToggle = !open;
    setOpen(afterToggle);

    if (afterToggle) onOpen();
  };

  if (!data || _.isEmpty(data)) return null;
  const isCreator = auth.isInfluencer();

  return (
    <>
      {createPortal(
        <div
          className={clsx(
            'z-[1200] fixed right-[40px]',
            isCreator && 'bottom-[120px]',
            !isCreator && 'bottom-[35px]',
          )}
        >
          {open ? (
            <ClipboardPanel
              close={() => setOpen(false)}
              data={data}
              deleteItem={deleteItem}
              clearAll={clearAll}
              paste={paste}
              disabledPaste={disabledPaste}
            />
          ) : null}
          <Tooltip
            title="There are items in your clipboard"
            placement="left"
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: 'black',
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: 500,
                  fontFamily: 'inherit',
                  width: '120px',
                },
              },
            }}
          >
            <div
              onClick={handleToggle}
              className={clsx(
                'relative w-[60px] h-[60px] rounded-[30px] flex justify-center items-center cursor-pointer',
                sprinkles({ bg: 'P-80' }),
              )}
            >
              <FontAwesomeIcon
                icon={open ? faClose : faSquareArrowDownRight}
                className="w-[20px] h-[20px] text-white"
              />
            </div>
          </Tooltip>
        </div>,
        document.body,
      )}
    </>
  );
};
